export default {
    visitor: 'ผู้เยี่ยมเยือน',
    visitorLists: 'รายชื่อผู้เยี่ยมเยือน',
    visitorActivity: 'บันทึกการมาเยือน'
}
